import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import { PageHeader } from '../../../Common';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import services from '../services';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Icon from '@material-ui/core/Icon';
import Avatar from '@material-ui/core/Avatar';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";

import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { parse } from 'date-fns';
import MaterialTable from 'material-table'
import tokenService from "../../../Common/tokenDecoder";
import MessageModal from '../../../UI/Modal/MessageModal';

const screenCode = 'MANUALLEAFCOLLECTION';


const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
    fontSize: 10,
  },
  root2: {
    minWidth: 45,
  },
  title: {
    fontSize: 12,
  },
  pos: {
    marginBottom: 12,
  },
  btncolor: {
    background: '#10BA57'
  },
  btnroot: {
    backgroundColor: '#10BA57',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: '30px',
    padding: '0 20px',
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    "&:hover": {
      //you want this to be the same as the backgroundColor above
      backgroundColor: "#049C44"
    }

  },
  card: {
    alignContent: 'center'
  },

  label: {
    textTransform: 'capitalize',
  }
}));



export function ManualLeafAddEdit(props) {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const [groups, setGroups] = useState()
  const [collectionPoint, setCollectionPoint] = useState();
  const [factoriesData, setFactoriesData] = useState();
  const [customer, setCustomer] = useState([]);
  const [deleteingid, setDeleteingid] = useState()
  const [customerSearchData, setCustomerSearchData] = useState({
    groupID: '0',
    operationEntityID: '0',
    collectionPointID: '0',
  });
  const [expanded, setExpanded] = React.useState(true);

  const [selectedCustomer, setSelectedCustomer] = useState({
    address1: "",
    address2: "",
    address3: "",
    cardNumber: "",
    collectionPointCode: "",
    customerCardPin: "",
    customerID: 0,
    customerName: "",
    customerRegistrationNumber: "",
    dateOfBirth: "",
    firstName: "",
    genderID: "",
    lastName: "",
    mobileNo: "",
    nic: "",
    secondName: ""
  });

  const [bagDetails, setBagDetails] = useState({
    id: 0,
    bagCount: "",
    totalAmount: "",
    reason: "",
    date: new Date().toISOString(),
    collectionTypeID: ""
  });
  const [collectionTypes, setCollectionTypes] = useState([]);
  const [fields, setFeilds] = useState();

  const [state, setState] = useState({
    columns: [
      { title: 'Collection Type', field: 'collectionTypeID', headerStyle: { textAlign: "center" } },
      { title: 'Bag Count', field: 'bagCount', type: 'numeric', headerStyle: { textAlign: "center" } },
      { title: 'Amount', field: 'totalAmount', type: 'numeric', headerStyle: { textAlign: "center" } },
      {
        title: 'Reason',
        field: 'reason',
        lookup: { 1: 'İstanbul', 2: 'Şanlıurfa' },
        headerStyle: { textAlign: "center" }
      },

    ],
    data: [],

  });

  const [tableHook, setTableHook] = useState([]);
  const [isAddHide, setIsAddHide] = useState(true);

  useEffect(() => {
    addButtonDisable();

  }, [bagDetails.reason]);
  useEffect(() => {
    addButtonDisable();

  }, [bagDetails.bagCount]);
  useEffect(() => {
    addButtonDisable();

  }, [bagDetails.totalAmount]);
  useEffect(() => {
    addButtonDisable();

  }, [bagDetails.collectionTypeID]);

  async function addButtonDisable() {
    if (bagDetails.reason == 0 || bagDetails.bagCount == "" || bagDetails.collectionTypeID == 0 || bagDetails.totalAmount == "") {
      setIsAddHide(true)
    }
    else {
      setIsAddHide(false)
    }
  }


  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true })
  }

  useEffect(() => {
    setGroupDropDownData();

  }, []);


  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Save/ Edit success"
  })

  async function setGroupDropDownData() {
    const result = await services.getGroups()
    setGroups(result)
  }


  function handleClose() {
    setOpen(false);
  }

  async function handleApprove1(e) {
    e.preventDefault()
    var dataArray = [];
    dataArray = state.data;
    var index = dataArray.findIndex(x => x.id === { deleteingid });

    dataArray.splice(index);

    setState({
      ...state,
      data: dataArray
    }
    )

    setOpen(false)
    setDeleteingid()

  }

  function handleGroupChange(target) {

    setCustomerSearchData({
      ...customerSearchData,
      groupID: target.value,
      operationEntityID: '0',
      collectionPointID: '0'
    });
    getOperationEntitiesForDropdown(target.value);
  }

  async function getCustomers(collectionPointID) {
    let result = await services.getCustomersFromCollectionPoint(collectionPointID);

    setCustomer(result);
  }

  async function handleOperationEntityChange(target) {
    setCustomerSearchData({
      ...customerSearchData,
      operationEntityID: target.value,
      collectionPointID: '0'
    });

    var opID = target.value
    await CollectionPointsByOperationEntity(target.value);
    var res = await GetCollectionTypes(opID);
    setCollectionTypes(res);
  }



  function handleCollectionTypeChange(target) {
    setBagDetails({
      ...bagDetails,
      collectionTypeID: target.value
    });

  }

  async function getOperationEntitiesForDropdown(groupID) {
    const opEntities = await services.getAllOperationEntitiesForDropDown(groupID);
    setFactoriesData(opEntities);
  }

  async function CollectionPointsByOperationEntity(factoryID) {
    let filteredData = await services.getCollectionPointByOperationEntityId(factoryID);
    setCollectionPoint(filteredData)
  }

  async function handleBagDetailsChange(target) {
    setBagDetails({
      ...bagDetails,
      [target.name]: target.value
    })
  }

  function handleCollectionPointChange(target) {
    setCustomerSearchData({
      ...customerSearchData,
      collectionPointID: target.value
    });
    getCustomers(parseInt(target.value))
  }

  function renderDropDown(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
      }
    }
    return items;
  }

  function renderCollectionTypeeDropDown(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={value}>{value}</MenuItem>)
      }
    }
    return items;
  }

  function saveToBagDetails() {
    var dataArray = [];
    dataArray = state.data;
    var lengthId = dataArray.length
    var cName = findCollectionType(bagDetails.collectionTypeID)

    dataArray.push(
      {
        id: lengthId + 1,
        bagCount: parseInt(bagDetails.bagCount),
        totalAmount: parseInt(bagDetails.totalAmount),
        reason: bagDetails.reason,
        collectionTypeID: parseInt(bagDetails.collectionTypeID),
        collectionTypeName: cName
      }
    );
    setState({
      ...state,
      data: dataArray
    }
    );

  }
  function handleSelectedRegNo(value) {
    setExpanded(false);
    setSelectedCustomer(value);
  }

  function handleDeleteRecord(id) {
    setDeleteingid(id)
    setOpen(true)
  }

  async function handleSubmit() {
    var arrayObj = [];
    var token = tokenService.getUserDetailsFromToken();
    if (selectedCustomer.customerID === 0) {

      setMessageModel({ ...messageModel, hidden: false, type: "Error", disciption: "Pleace Select Customer" })
      setTimeout(() => {
        setMessageModel({ ...messageModel, hidden: true });

      }, 1500);

    }
    else {
      console.log("test 1")
      state.data.forEach(element => {
        var obj = {

          collectionTypeID: element.collectionTypeID,
          customerID: parseInt(selectedCustomer.customerID),
          cardNumber: selectedCustomer.cardNumber,
          numberOfUnit: element.bagCount,
          totalAmount: element.totalAmount,

        }
        arrayObj.push(obj);

      });

      var formdata = {
        collectionPointID: parseInt(customerSearchData.collectionPointID),
        isActive: true,
        createdBy: parseInt(token.id),
        createdDate: bagDetails.date,
        manualLeafEntryModels: arrayObj
      }

      console.log("formdata", formdata)

      var response = await services.saveTransaction(formdata);

      console.log("response.data", response.data)
      if (response.data) {

        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode);
      }

    }

  }

  function afterSuccessfulyChanged(response) {
    if (response === "Success") {
      // clearState();
      setTimeout(() => {
        setMessageModel({ ...messageModel, hidden: true });
        setState({
          ...state,
          data: []
        })
      }, 1500);
    }
  }

  async function GetCollectionTypes(opid) {
    return await services.GetCollectionTypeByOperationEntity(parseInt(opid))

  }

  function findCollectionType(id) {
    var res = ""

    for (const [key, value] of Object.entries(collectionTypes)) {
      if (key == parseInt(id)) {

        res = value
      }
    }
    return res;
  }




  return (
    <Fragment>

      <Card className={classes.root}>
        <form className={classes.root} noValidate autoComplete="off">
          <CardContent>
            <PageHeader
              title="Add Manual Leaf Collection"
              isButtonEnable={true}
              buttonText="Add Manual Leaf Entry"
              path="/manualLeafCollection" />

            <br />

            <Grid container spacing={3}>

              <Grid item xs={3} >
                <TextField
                  id="groupID"
                  select
                  fullWidth
                  label="Group *"
                  value={customerSearchData.groupID}
                  onChange={(e) => handleGroupChange(e.target)}>
                  <MenuItem value="0">--Select Group Name--</MenuItem>
                  {renderDropDown(groups)}
                </TextField>
              </Grid>

              <Grid item xs={3}>
                <TextField
                  id="opreationID"
                  select
                  fullWidth
                  label="Factory *"
                  onChange={(e) => handleOperationEntityChange(e.target)}
                  value={customerSearchData.operationEntityID}
                >
                  <MenuItem value="0">--Select operationEntity Name--</MenuItem>
                  {renderDropDown(factoriesData)}
                </TextField>
              </Grid>

              <Grid item xs={3}>
                <TextField
                  id="routID"
                  select
                  fullWidth
                  label="Root *"
                  onChange={(e) => handleCollectionPointChange(e.target)}
                  value={customerSearchData.collectionPointID}
                >
                  <MenuItem value="0">--Select Route Name--</MenuItem>
                  {renderDropDown(collectionPoint)}
                </TextField>

              </Grid>

              <Grid item xs={2} >
                <TextField
                  id="date"
                  name="date"
                  fullWidth
                  type='date'
                  label="Date *"
                  onChange={(e) => handleBagDetailsChange(e.target)}
                  value={bagDetails.date}
                >

                </TextField>
              </Grid>


            </Grid>
            <br />
            <br /><br />
            <Grid container spacing={3}>
              <Grid item xs={3} >

                <Autocomplete
                  fullWidth
                  size="small"
                  id="combo-box-demo"
                  options={customer}
                  getOptionLabel={(option) => option.customerRegistrationNumber + "-" + option.customerName}
                  onChange={(event, value) => handleSelectedRegNo(value)}
                  renderInput={(params) => <TextField {...params} label="Registration NO *" variant="outlined" />}
                />
              </Grid>
              <Grid item xs={6} >

              </Grid>
            </Grid>

            <br /><br />
            <Card className={classes.root2}>


              <CardContent>
                <Grid container spacing={3}>


                  <Grid item xs={2} >
                    <TextField
                      id="bagCount"
                      name="bagCount"
                      fullWidth
                      type='number'
                      label="Bag Count *"
                      onChange={(e) => handleBagDetailsChange(e.target)}
                      value={bagDetails.bagCount}
                    >

                    </TextField>
                  </Grid>
                  <Grid item xs={2} >
                    <TextField
                      id="routID"
                      name="totalAmount"
                      fullWidth
                      type='number'
                      label="Total amount *"
                      onChange={(e) => handleBagDetailsChange(e.target)}
                      value={bagDetails.totalAmount}
                    >

                    </TextField>
                  </Grid>

                  <Grid item xs={3} >
                    <TextField
                      id="collectionTypeID"
                      select
                      fullWidth
                      label="Collection Type *"
                      value={bagDetails.collectionTypeID}
                      onChange={(e) => handleCollectionTypeChange(e.target)}>
                      <MenuItem value="0">--Select Collection Type--</MenuItem>
                      {renderDropDown(collectionTypes)}
                    </TextField>
                  </Grid>

                  <Grid item xs={3} >
                    <TextField
                      id="reason"
                      name='reason'
                      select
                      fullWidth
                      label="Reason *"
                      onChange={(e) => handleBagDetailsChange(e.target)}
                      value={bagDetails.reason}
                    >
                      <MenuItem value="0">--Select Reason Name--</MenuItem>
                      <MenuItem value="Device Isuue">Device Isuue</MenuItem>
                    </TextField>
                  </Grid>


                </Grid>
              </CardContent>
              <CardActions className={classes.card} alignContent={'right'}>
                <Grid container justify="flex-end">
                  <Button
                    onClick={() => saveToBagDetails()}
                    variant="contained"
                    className={classes.btnroot}
                    disabled={isAddHide}
                    endIcon={<Icon>saveAltIcon </Icon>}
                  >Add
                  </Button>
                </Grid>
              </CardActions>

            </Card>
            <br /><br />



            <Grid container spacing={3}>
              <Grid item xs={12} >

                <TableContainer component={Paper}>
                  <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                      <TableRow>

                        <TableCell align="center">Collection Type</TableCell>
                        <TableCell align="center">Bag Count</TableCell>
                        <TableCell align="center">Total Weight</TableCell>
                        <TableCell align="center">Reason</TableCell>
                        <TableCell align="center">Action</TableCell>

                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {state.data.map((row) => {
                        return (

                          <TableRow >
                            <TableCell align="center">{row.collectionTypeName}</TableCell>
                            <TableCell align="center" component="th" scope="row">
                              {row.bagCount}
                            </TableCell>
                            <TableCell align="center">{row.totalAmount}</TableCell>
                            <TableCell align="center">{row.reason}</TableCell>
                            <TableCell align="center">
                              {
                                <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => handleDeleteRecord(row.id)} >
                                  <Icon>deleteIcon </Icon>
                                </IconButton>
                              }
                            </TableCell>
                          </TableRow>
                        )
                      })
                      }

                    </TableBody>
                  </Table>
                  <div>

                    <Dialog
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">{"Approve"}</DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          Are you sure you want to Delete this record?
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleClose} color="primary">
                          No
                        </Button>
                        <Button onClick={handleApprove1} color="primary" autoFocus>
                          Yes
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </TableContainer>

              </Grid>
            </Grid>
          </CardContent>

          <CardActions className={classes.card} alignContent={'right'}>
            <Grid container justify="flex-end">
              <Button
                onClick={() => handleSubmit()}
                variant="contained"
                className={classes.btnroot}
                endIcon={<Icon>cloudUploadIcon </Icon>}
              >
                Upload
              </Button>
            </Grid>
          </CardActions>
        </form>
      </Card>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  )
}